import React from "react";
import { useIntl } from "react-intl";
import { useIssueNumberListFormatter } from "../../hooks/useIssueNumberListFormatter";
import { NUMBERING_MESSAGE_PREFIX as MESSAGE_PREFIX } from "../../utils/issueNumberList";
import tableCss from "./VolumeWindowPreview.module.css";
import css from "./ContinuousNumberingPreview.module.css";
var AFTER_CLASS = {
    CREATED: tableCss.createdMark,
    RENUMBERED: tableCss.changedMark,
    UNCHANGED: css.sameMark,
    OUT_OF_SERIES: css.sameMark,
};
var STATUS_CLASS = {
    CREATED: tableCss.createdMark,
    RENUMBERED: tableCss.changedMark,
    UNCHANGED: css.sameMark,
    OUT_OF_SERIES: css.outOfSeries,
};
var numbersShownAfter = function (volume) {
    return volume.status === "CREATED" || volume.status === "RENUMBERED"
        ? volume.numbersAfter
        : volume.numbersBefore;
};
export var ContinuousNumberingPreview = function (_a) {
    var preview = _a.preview, continuous = _a.continuous;
    var formatMessage = useIntl().formatMessage;
    var formatNumbers = useIssueNumberListFormatter();
    var lastVolume = preview.volumes[preview.volumes.length - 1];
    var noVolumeAfterCurrent = (lastVolume === null || lastVolume === void 0 ? void 0 : lastVolume.label) === preview.currentVolumeLabel;
    return (React.createElement("div", null,
        React.createElement("div", { className: css.previewTitle }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".preview.title") })),
        React.createElement("table", { className: tableCss.afterTable },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".preview.volume") })),
                    React.createElement("th", null, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".preview.before") })),
                    React.createElement("th", { "aria-hidden": "true" }),
                    React.createElement("th", null, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".preview.after") })),
                    React.createElement("th", { "aria-hidden": "true" }))),
            React.createElement("tbody", null, preview.volumes.map(function (volume) {
                var _a;
                return (React.createElement("tr", { key: (_a = volume.volumeId) !== null && _a !== void 0 ? _a : "created-".concat(volume.label) },
                    React.createElement("td", null,
                        React.createElement("strong", null, volume.label),
                        volume.inSeries && (React.createElement("span", { className: css.seriesBadge }, formatMessage({
                            id: "".concat(MESSAGE_PREFIX, ".preview.inSeries"),
                        })))),
                    React.createElement("td", null, formatNumbers(volume.numbersBefore)),
                    React.createElement("td", { className: css.arrow }, "\u2192"),
                    React.createElement("td", null,
                        React.createElement("span", { className: AFTER_CLASS[volume.status] }, formatNumbers(numbersShownAfter(volume)))),
                    React.createElement("td", null,
                        React.createElement("span", { className: STATUS_CLASS[volume.status] }, formatMessage({
                            id: "".concat(MESSAGE_PREFIX, ".preview.status.").concat(volume.status),
                        })))));
            }))),
        continuous && noVolumeAfterCurrent && (React.createElement("div", { className: css.legendLine }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".preview.laterVolumes") }, { volume: preview.currentVolumeLabel })))));
};
